<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <StaticViewHeading icon="manage_accounts" subtitle="Administración de roles por perfil" />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions :show-shortcut="false" /></div>
          </div>
        </section>
      </b-card>

      <b-row>
        <b-col cols="12" md="4" v-if="hasPermissionModule(modules.personal)">
          <b-card header-tag="header" footer-tag="footer">
            <template v-slot:header>
              <b-row>
                <b-col sm="5">
                  <h6 class="mb-0 card-header-roles-custom">Staff</h6>
                </b-col>
                <b-col sm="7">
                  <b-button @click="addPersonal()" type="button" variant="link" class="list-view-icon-btn list-view-icon-btn--primary float-right" v-b-tooltip.hover title="Agregar rol de Staff" aria-label="Agregar rol de Staff">
                    <AppIcon name="add" />
                  </b-button>
                </b-col>
              </b-row>
            </template>

            <b-table class="app-table"
                    responsive="sm"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="tablePersonal.items"
                    :fields="fieldsWithAction(tablePersonal.fields)"
                    :stacked="isMobileViewport ? 'md' : false"
                    v-if="tablePersonal.items.length">

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right no-caret size="sm" variant="link" boundary="window" toggle-class="app-table-action-toggle">
                    <template #button-content><AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" /><span v-if="isMobileViewport" class="app-table-action-label">Opciones</span></template>
                    <b-dropdown-item @click="editPersonal(data.item)">
                      <AppIcon name="edit" class="text-primary mr-1" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="deletePersonal(data.item)">
                      <AppIcon name="delete" class="text-danger mr-1" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>

          </b-card>
        </b-col>

        <b-col cols="12" md="4" v-if="hasPermissionModule(modules.cliente)">
          <b-card header-tag="header" footer-tag="footer">
            <template v-slot:header>
              <b-row>
                <b-col sm="5">
                  <h6 class="mb-0 card-header-roles-custom">Cliente</h6>
                </b-col>
                <b-col sm="7">
                  <b-button @click="addCliente()" type="button" variant="link" class="list-view-icon-btn list-view-icon-btn--primary float-right" v-b-tooltip.hover title="Agregar rol de Cliente" aria-label="Agregar rol de Cliente">
                    <AppIcon name="add" />
                  </b-button>
                </b-col>
              </b-row>
            </template>

            <b-table class="app-table"
                    responsive="sm"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="tableCliente.items"
                    :fields="fieldsWithAction(tableCliente.fields)"
                    :stacked="isMobileViewport ? 'md' : false"
                    v-if="tableCliente.items.length">

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right no-caret size="sm" variant="link" boundary="window" toggle-class="app-table-action-toggle">
                    <template #button-content><AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" /><span v-if="isMobileViewport" class="app-table-action-label">Opciones</span></template>
                    <b-dropdown-item @click="editCliente(data.item)">
                      <AppIcon name="edit" class="text-primary mr-1" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="deleteCliente(data.item)">
                      <AppIcon name="delete" class="text-danger mr-1" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>

          </b-card>
        </b-col>

        <b-col cols="12" md="4" v-if="hasPermissionModule(modules.proveedor)">
          <b-card header-tag="header" footer-tag="footer">
            <template v-slot:header>
              <b-row>
                <b-col sm="5">
                  <h6 class="mb-0 card-header-roles-custom">Proveedor</h6>
                </b-col>
                <b-col sm="7">
                  <b-button @click="addProveedor()" type="button" variant="link" class="list-view-icon-btn list-view-icon-btn--primary float-right" v-b-tooltip.hover title="Agregar rol de Proveedor" aria-label="Agregar rol de Proveedor">
                    <AppIcon name="add" />
                  </b-button>
                </b-col>
              </b-row>
            </template>

            <b-table class="app-table"
                    responsive="sm"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="tableProveedor.items"
                    :fields="fieldsWithAction(tableProveedor.fields)"
                    :stacked="isMobileViewport ? 'md' : false"
                    v-if="tableProveedor.items.length">

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right no-caret size="sm" variant="link" boundary="window" toggle-class="app-table-action-toggle">
                    <template #button-content><AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" /><span v-if="isMobileViewport" class="app-table-action-label">Opciones</span></template>
                    <b-dropdown-item @click="editProveedor(data.item)">
                      <AppIcon name="edit" class="text-primary mr-1" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="deleteProveedor(data.item)">
                      <AppIcon name="delete" class="text-danger mr-1" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>

          </b-card>
        </b-col>
      </b-row>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="manage_accounts" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>

        <b-row>
          <b-col>
            <b-form-group label="Nombre">
              <b-form-input type="text"
                            size="sm"
                            v-model="form.name"
                            required
                            placeholder="Ingresar nombre del rol">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import StaticViewHeading from '@/components/inc/module/StaticViewHeading'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: { StaticViewHeading, TabHeaderActions },
    data: () => {
      return {
        tablePersonal : {
          items: [],
          fields: [
            {key: 'name', label: 'Nombre'},
            {key: 'f_action', label:''},
          ],
        },
        tableCliente : {
          items: [],
          fields: [
            {key: 'name', label: 'Nombre'},
            {key: 'f_action', label:''},
          ],
        },
        tableProveedor : {
          items: [],
          fields: [
            {key: 'name', label: 'Nombre'},
            {key: 'f_action', label:''},
          ],
        },
        isMobileViewport: false,
        form: {
          id: 0,
          name: '',
          profile_id: 0,
        },
        modal: {
          form: {
            active: false,
            title: ''
          }
        },
        arr: {
          permissions: []
        },
        modules: {
          personal: Modules.PERSONAL,
          cliente: Modules.CLIENTES,
          proveedor: Modules.PROVEEDORES
        }
      }
    },
    mounted() {
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.cargar()
      this.cargarPermissions()
    },
    beforeDestroy() {
      if (this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
    },
    methods: {
      updateMobileViewport (event) {
        this.isMobileViewport = event.matches
      },
      fieldsWithAction (fields) {
        return fields.map(field => field.key === 'f_action' ? Object.assign({}, field, { label: this.isMobileViewport ? 'Acción' : '', thClass: 'align-middle' }) : field)
      },
      cargar () {
        var result = serviceAPI.obtener()

        result.then((response) => {
          var data = response.data
          this.tablePersonal.items = []
          this.tableCliente.items = []
          this.tableProveedor.items = []

          data.forEach(element => {
            if( element.profile_id == Profiles.PERSONAL ) {
              this.tablePersonal.items.push(element)
            }

            if( element.profile_id == Profiles.CLIENTE ) {
              this.tableCliente.items.push(element)
            }

            if( element.profile_id == Profiles.PROVEEDOR ) {
              this.tableProveedor.items.push(element)
            }
          });
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });
      },
      cargarPermissions () {
        let loader = this.$loading.show();
        var result = serviceAPI.obtenerPermisos()

        result.then((response) => {
          var data = response.data
          this.arr.permissions = data
          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      },
      hasPermissionModule(module_id) {
        var status = false
        this.arr.permissions.forEach(element =>{
          if(element.id == module_id){
            status = true
          }
        })
        return status
      },
      addPersonal() {
        this.modal.form.title = "Nuevo >> Rol del perfil <Staff>"
        this.addRole(Profiles.PERSONAL)
      },
      editPersonal(item) {
        this.modal.form.title = "Edicción >> Rol del perfil <Staff>"
        this.editRole(item)
      },
      deletePersonal(item) {
        this.form.id = item.id
        this.form.name = item.name
        this.form.profile_id = 0

        this.$bvModal.msgBoxConfirm('¿Desea borrar el item (' + this.form.id + ') - '+ this.form.name + '?', {
          title: 'Borrar >> Rol del perfil <Staff>',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: "danger",
          headerTextVariant: "white",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            this.remove()
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      addCliente() {
        this.modal.form.title = "Nuevo >> Rol del perfil <Cliente>"
        this.addRole(Profiles.CLIENTE)
      },
      editCliente(item) {
        this.modal.form.title = "Edicción >> Rol del perfil <Cliente>"
        this.editRole(item)
      },
      deleteCliente(item) {
        this.form.id = item.id
        this.form.name = item.name
        this.form.profile_id = 0

        this.$bvModal.msgBoxConfirm('¿Desea borrar el item (' + this.form.id + ') - '+ this.form.name + '?', {
          title: 'Borrar >> Rol del perfil <Cliente>',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: "danger",
          headerTextVariant: "white",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            this.remove()
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      addProveedor() {
        this.modal.form.title = "Nuevo >> Rol del perfil <Proveedor>"
        this.addRole(Profiles.PROVEEDOR)
      },
      editProveedor(item) {
        this.modal.form.title = "Edicción >> Rol del perfil <Proveedor>"
        this.editRole(item)
      },
      deleteProveedor(item) {
        this.form.id = item.id
        this.form.name = item.name
        this.form.profile_id = 0

        this.$bvModal.msgBoxConfirm('¿Desea borrar el item (' + this.form.id + ') - '+ this.form.name + '?', {
          title: 'Borrar >> Rol del perfil <Proveedor>',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: "danger",
          headerTextVariant: "white",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            this.remove()
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      addRole(role_id) {
        this.form.id = 0
        this.form.name = ''
        this.form.profile_id = role_id
        this.modal.form.active = true
      },
      editRole(item) {
        this.form.id = item.id
        this.form.name = item.name
        this.form.profile_id = item.profile_id
        this.modal.form.active = true
      },
      save() {
        let loader = this.$loading.show();
        let result
        if (this.form.id) {
          result = serviceAPI.editar(this.form);
        } else {
          result = serviceAPI.agregar(this.form);
        }

        result.then(() => {
          loader.hide()
          this.modal.form.active = false
          this.cargar()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      remove() {
        let loader = this.$loading.show();
        if (this.form.id) {
          var result = serviceAPI.eliminar(this.form.id);
        }

        result.then(() => {
          loader.hide()
          this.cargar()
          this.$awn.success("Registro eliminado");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      }
    }
  }
</script>

<style>
  .card-header-roles-custom {
    font-weight: 500;
    font-size: 15px;
  }
</style>
